<div class="button-container">
  @if (hasDelete) {
    <cw-action-icon icon="delete" (click)="onDelete($event)"></cw-action-icon>
  }
  <cw-action-icon icon="keyboard_arrow_right" (click)="onDetail($event)"></cw-action-icon>
</div>
